// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SeeMoreCard_wrapper__eKd7x","text":"SeeMoreCard_text__2YHxp"};